import { useSorting } from '@modules/shared/hooks';

import { Box, TableHead } from '../../../atoms';
import {
  StyledCaretDown,
  StyledCaretUp,
  StyledGreyCaretDown,
  StyledSortableTableHeadCell,
  StyledTableHeadCell,
  StyledTableHeadContent,
  StyledTableHeadRow,
} from './TableHeader.styles';
import { TableHeaderProps } from './TableHeader.types';

export function TableHeader<T>({ columns, onSortingChange, sortingEnabled = true }: TableHeaderProps<T>): JSX.Element {
  const { sorting, handleSorting: setSorting, isColumnSorted, isAscendingSorted } = useSorting();

  const handleSorting = (columnKey: string): void => {
    if (!sortingEnabled) return;

    setSorting(columnKey);
    onSortingChange(sorting);
  };

  return (
    <TableHead>
      <StyledTableHeadRow>
        {columns?.map((column, columnIndex) => {
          if (column.sort) {
            return (
              <StyledSortableTableHeadCell
                disabled={!sortingEnabled}
                onClick={() => handleSorting(column.key)}
                title={column.label}
                key={columnIndex}
                css={{ width: column.width }}
                data-testid={`table-head-cell-${column.key}`}
              >
                <StyledTableHeadContent>
                  <Box>{column.label}</Box>
                  {isColumnSorted(column.key) && isAscendingSorted(column.key) && (
                    <StyledCaretUp data-testid={`${column.key}-caret-up`} />
                  )}
                  {isColumnSorted(column.key) && !isAscendingSorted(column.key) && (
                    <StyledCaretDown data-testid={`${column.key}-caret-down`} />
                  )}
                  {!isColumnSorted(column.key) && <StyledGreyCaretDown data-testid={`${column.key}-caret-grey`} />}
                </StyledTableHeadContent>
              </StyledSortableTableHeadCell>
            );
          }
          return (
            <StyledTableHeadCell
              title={column.label}
              key={columnIndex}
              css={{ width: column.width }}
              data-testid={`table-head-cell-${column.key}`}
            >
              {column.label}
            </StyledTableHeadCell>
          );
        })}
      </StyledTableHeadRow>
    </TableHead>
  );
}
